import { colors, Color } from '../utils/colors';
import { shortDateFrom } from '../utils/date';
import { FaCheckCircle } from 'react-icons/fa';

export type Bar = {
  _id?: string;
  id: string;
  title: string;
  description?: string;
  color: Color;
  done: boolean;
  startDate: Date;
  endDate: Date;
  preferredY?: number;
};

export default ({ bar, editable }) => {
  if (!bar) {
    return null;
  }
  const colorBg = colors[bar.color].bg;
  const colorFg = colors[bar.color].fg;

  return (
    <div
      className={`relative w-full h-16 overflow-hidden text-left bg-white rounded-lg shadow-sm ${
        editable ? 'cursor-pointer' : ''
      } hover:shadow-md`}
    >
      <div
        className={`flex items-center justify-start px-5 py-1 w-full h-full bg-${colorBg} ${
          bar.done ? 'opacity-50' : ''
        }`}
      >
        {bar.done && (
          <div>
            {' '}
            <FaCheckCircle
              size={22}
              className={`mr-2 -ml-1 text-${colorFg} text-opacity-100 ${
                editable ? 'cursor-pointer' : ''
              }`}
            />
          </div>
        )}
        <div className="flex flex-col items-start justify-center w-full">
          <div className={`w-full text-base font-semibold text-${colorFg} truncate`}>
            {bar.title ? bar.title : <span className={`text-${colorFg} opacity-25`}>New item</span>}
          </div>
          {bar.description ? (
            <div className={`w-full text-xs font-normal text-${colorFg} text-opacity-75 truncate`}>
              {bar.description}
            </div>
          ) : (
            bar.startDate && (
              <div
                className={`w-full text-xs font-normal text-${colorFg} text-opacity-75 truncate`}
              >
                {shortDateFrom(bar.startDate)} &ndash; {shortDateFrom(bar.endDate)}
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};
